import { Close as CloseIcon } from '@mui/icons-material';
import { Dialog } from '@mui/material';
import alert from 'assets/img/reject-action.svg';
import { useStoreSelector } from 'v3/data/store';
import { setCancelationModalOpen, setRefundConflictModalOpen } from 'v3/data/store/cancellationNavigation/actions';
import { confirmationDialogPaperPropsStyle, StyledDialogContent, StyledIconButton } from 'v3/pages/OnlineContracting/Cancellation/Error/RefundConflictError/styles';
import { AlignIcon, Icon, SubTitleSection, TitleSection } from 'v3/pages/OnlineContracting/Cancellation/styles';

import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';
import { theme } from 'v3/styles/global-styles';

export const RefundConflictError = () => {
  const { isRefundConflictDialogOpen } = useStoreSelector((state) => state.cancellationNavigation);

  const handleClose = () => {
    setRefundConflictModalOpen(false);
    setCancelationModalOpen(false);
  };

  return (
    <Dialog open={isRefundConflictDialogOpen} PaperProps={{ sx: confirmationDialogPaperPropsStyle }}>
      <StyledIconButton onClick={handleClose}>
        <CloseIcon />
      </StyledIconButton>
      <StyledDialogContent>
        <AlignIcon>
          <Icon src={alert} alt="Alert" />
        </AlignIcon>
        <TitleSection>
          <HeadlineSmall>Não é possivel realizar a solicitação de reembolso do pedido faturado </HeadlineSmall>
          <SubTitleSection>
            <BodySmallRegular color={theme.palette.info.main}>
              Aguarde a emissão de nota fiscal e término do processamento de financiamento para solicitar o cancelamento
            </BodySmallRegular>
          </SubTitleSection>
        </TitleSection>
      </StyledDialogContent>
    </Dialog>
  );
};
